import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const ProceduresRoutes: RouteBundle = {
  domain: 'procedures',
  routes: [
    {
      urlPattern: ':currentUserUrl/procedures/:procedureId',
      handler: EditorRoutes.procedureEditor.bind(EditorRoutes),
    },
    {
      urlPattern: ':currentUserUrl/procedures/:procedureId/v/:flowchartVersionId',
      handler: EditorRoutes.procedureFlowchartVersionViewer.bind(EditorRoutes),
    },
    {
      urlPattern: 'procedure-runs/:procedureRunId',
      handler: EditorRoutes.procedureRunEditor.bind(EditorRoutes),
    },
  ],
};
